import { Translator } from 'Translator';
import ChevronIcon from 'components/icons/ChevronIcon';
import { SearchFilters } from 'model/Filters';
import { convertSearchFiltersToLocalSearchFilters } from 'modules/locals/utils/LocalSearchFilterHelper';
import LocalSearchUrlCompiler from 'modules/locals/utils/LocalSearchUrlCompiler';
import React from 'react';
import { useHistory } from 'react-router-dom';

const CSS = require('./SeeAllButton.less');

type SeeAllButtonProps = {
  filters: SearchFilters;
};

const SeeAllButton = ({ filters }: SeeAllButtonProps) => {
  const history = useHistory();
  if (!filters.city && !filters.country) {
    return null;
  }

  const localSearchFilters = convertSearchFiltersToLocalSearchFilters({
    searchFilters: filters,
  });
  const seeAllPath = LocalSearchUrlCompiler.compile(localSearchFilters);

  const routeToLocalSearch = () => {
    history.push(`/l${seeAllPath}`);
  };

  const getSeeAllText = () => {
    const otherFilter = localSearchFilters.activeFilters.find(
      (f) => f.uid === 'other',
    );
    if (
      otherFilter &&
      otherFilter.options.find((f) => f.value === 'family-friendly')
    ) {
      return Translator.translate(
        'SearchPage.HostSlider.viewAllFamilyFriendly',
        {},
        true,
        'View all family friendly guides',
      );
    }

    const languageFilter = localSearchFilters.activeFilters.find(
      (f) => f.uid === 'languages',
    );
    if (languageFilter && languageFilter.options.length > 0) {
      const language = languageFilter.options[0].name;
      return Translator.translate(
        'SearchPage.HostSlider.viewAllLanguage',
        { language },
        true,
        'View all {language} speaking guides',
      );
    }

    return Translator.translate(
      'SearchPage.HostSlider.viewAll',
      {},
      true,
      'View all local guides',
    );
  };

  return (
    <button onClick={routeToLocalSearch} className={CSS.SeeAllLink}>
      {getSeeAllText()} <ChevronIcon direction="right" className={CSS.Icon} />
    </button>
  );
};

export default SeeAllButton;
